import type { GetRequestsListItem } from "@nlc/shared-types";
import type { ReactNode } from "react";

import {
  InlineAssigneeCell,
  InlineBrandCell,
  InlineComplexityCell,
  InlineDueDateCell,
  InlineStatusCell,
} from "./inlineEditableCells";

// Type alias for inline edit data
type RequestRowData = GetRequestsListItem;

// Cell renderer functions for table configurations
// Note: These renderers accept 'any' row type to work with various table configs
// The actual data passed must contain the required fields (id, status, etc.)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inlineStatusCell = (value: unknown, row: any): ReactNode => (
  <InlineStatusCell data={row as RequestRowData} value={value} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inlineComplexityCell = (value: unknown, row: any): ReactNode => (
  <InlineComplexityCell data={row as RequestRowData} value={value} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inlineAssigneeCell = (value: unknown, row: any): ReactNode => (
  <InlineAssigneeCell data={row as RequestRowData} value={value} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inlineDueDateCell = (value: unknown, row: any): ReactNode => (
  <InlineDueDateCell data={row as RequestRowData} value={value} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inlineBrandCell = (value: unknown, row: any): ReactNode => (
  <InlineBrandCell data={row as RequestRowData} value={value} />
);
